import {
  EmbedDimensionEnum,
  EmbedOptionEnum,
  type EmbedOptionsState,
} from "./types";

export const defaultEmbedOptions: EmbedOptionsState = {
  [EmbedOptionEnum.CHART]: true,
  [EmbedOptionEnum.ODDS]: true,
  [EmbedOptionEnum.CONSENSUS_ONLY]: false,
  [EmbedOptionEnum.BORDER]: true,
  [EmbedOptionEnum.DARK_MODE]: false,
};

export const labelByEmbedOption: Record<EmbedOptionEnum, string> = {
  [EmbedOptionEnum.CHART]: "Chart",
  [EmbedOptionEnum.ODDS]: "Odds (live)",
  [EmbedOptionEnum.CONSENSUS_ONLY]: "Consensus only",
  [EmbedOptionEnum.BORDER]: "Border",
  [EmbedOptionEnum.DARK_MODE]: "Dark mode",
};

export const labelByEmbedDimension: Record<EmbedDimensionEnum, string> = {
  [EmbedDimensionEnum.HEIGHT]: "H",
  [EmbedDimensionEnum.WIDTH]: "W",
};
